import React from "react";

const ProductSectionTitle = ({ title }) => {
  return (
    <div className="product-section-title">
      <div className="product-section-top">
        <div className="product-section-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
            fill="white"
            className="play-icon"
          >
            <path d="M3 2.5L9 6L3 9.5V2.5Z" />
          </svg>
        </div>
        <h2 className="product-section-text">{title}</h2>
      </div>
      <div className="product-section-line"></div>
    </div>
  );
};

export default ProductSectionTitle;